import { RADIUS, SPACE, T } from '@/design/tokens';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from './Button';

/**
 * Renders a small toast prompting the user when a new service-worker version
 * is ready. We do NOT auto-reload — interrupting an in-progress form fill is
 * hostile UX. The user clicks Refresh, we apply the update.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('[sw] registration failed', error);
    },
  });

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        left: '50%',
        bottom: SPACE.lg,
        transform: 'translateX(-50%)',
        background: T.card,
        border: `1px solid ${T.border}`,
        borderLeft: `3px solid ${T.accent}`,
        borderRadius: RADIUS.md,
        padding: `${SPACE.sm}px ${SPACE.md}px`,
        display: 'flex',
        alignItems: 'center',
        gap: SPACE.md,
        zIndex: 1000,
        maxWidth: 'calc(100vw - 32px)',
      }}
    >
      <span style={{ color: T.text, fontSize: 13 }}>A new version is ready.</span>
      <Button size="sm" onClick={() => void updateServiceWorker(true)}>
        Refresh
      </Button>
      <Button size="sm" variant="ghost" onClick={() => setNeedRefresh(false)}>
        Later
      </Button>
    </div>
  );
}
